import { Button, Container, Grid, TextField } from "@mui/material";
import BackIcon from "@mui/icons-material/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import * as queryString from "query-string";
import React, { useEffect, useState } from "react";
import MultiSelect from "react-multi-select-component";
import { useHistory } from "react-router-dom";
import CustomList from "../../components/List/CustomList";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAreaList, getBreakDownReasonGroupList, getPoolById, getPoolRelationById, getMaintenanceTypeList, editPoolRelation, getBreakdownReasonPlaceData } from "../../store/actions/PoolActions";
import Autocomplete from "@mui/material/Autocomplete";


var areaList = [];
var maintenanceTypeList = [];
var breakDownReasonGroupsList = [];
var breakDownReasonPlaceList = [];

export default function AddRelationToPool() {
    let [data, setData] = useState([]);
    let [allArea, setAllArea] = useState([]);
    let [allBreakdownReason, setAllBreakdownReason] = useState([]);
    let [allMaintenanceType, setAllMaintenanceType] = useState([]);
    let [allBreakdownReasonPlace, setAllBreakdownReasonPlace] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();

    useEffect(() => {
        LoadHandler();
    }, []);

    const { poolById, areas, maintenanceTypes, breakDownReasonGroups, poolRelationsById, editedPoolRelation, breakdownReasonPlaceData } = useSelector(({ pool }) => pool);

    useEffect(() => {
        if (poolById?.resultObject) {
            setData(poolById.resultObject);
            setPageLoaded(true);
            dispatch(getAreaList());
            dispatch(getBreakdownReasonPlaceData());
        }
    }, [poolById]);

    useEffect(() => {
        if (areas?.resultObject) {
            setAllArea(Object.values(areas.resultObject));
            areaList = Object.values(areas.resultObject).map((item,index) => ({
                label: item.name,
                value: item.id,
                name: item.name
            }));

            dispatch(getMaintenanceTypeList());
        }
    }, [areas]);

    //use effect for getBreakdownReasonPlaceData    
    useEffect(() => {
        if (breakdownReasonPlaceData?.resultObject) {
            setAllBreakdownReasonPlace(Object.values(breakdownReasonPlaceData.resultObject));
            breakDownReasonPlaceList = Object.values(breakdownReasonPlaceData.resultObject).map((item,index) => ({
                label: item.name,
                value: item.id,
                name: item.name
            }));
        }
    }, [breakdownReasonPlaceData]);

    useEffect(() => {
        if (maintenanceTypes?.resultObject) {
            setAllMaintenanceType(Object.values(maintenanceTypes.resultObject));
            maintenanceTypeList = Object.values(maintenanceTypes.resultObject).map((item,index) => ({
                label: item.name,
                value: item.id,
                name: item.name
            }));

            dispatch(getBreakDownReasonGroupList());
        }
    }, [maintenanceTypes]);

    useEffect(() => {
        if (breakDownReasonGroups?.resultObject) {
            setAllBreakdownReason(Object.values(breakDownReasonGroups.resultObject));

            breakDownReasonGroupsList = Object.values(breakDownReasonGroups.resultObject).map((item,index) => ({
                label: item.breakdownReasonGroupLocalizationName ?? item.name,
                value: item.id,
                name: item.breakdownReasonGroupLocalizationName ?? item.name
            }));

            dispatch(getPoolRelationById(queryString.parse(window.location.search).id));
        }
    }, [breakDownReasonGroups]);

    useEffect(() => {
        if (poolRelationsById?.resultObject) {
            var filteredArea = Object.values(allArea).filter(function (item) {
                return poolRelationsById.resultObject.areaIds.indexOf(item.id) > -1;
            });
            setSelectedArea(
                filteredArea.map((item, index) => ({
                    label: item.name,
                    value: item.id,
                    name: item.name
                }))
            );

            var filteredmaintenanceType = Object.values(allMaintenanceType).filter(function (item) {
                return poolRelationsById.resultObject.maintenanceTypeIds.indexOf(item.id) > -1;
            });
            setSelectedMaintenanceType(
                filteredmaintenanceType.map((item, index) => ({
                    label: item.name,
                    value: item.id,
                    name: item.name
                }))
            );

            var filteredBreakdownReason = Object.values(allBreakdownReason).filter(function (item) {
                return poolRelationsById.resultObject.breakdownReasonGroupIds.indexOf(item.id) > -1;
            });
            setSelectedBreakdownReason(
                filteredBreakdownReason.map((item, index) => ({
                    label: item.name,
                    value: item.id,
                    name: item.name
                }))
            );

            var filteredBreakdownReasonPlace = Object.values(allBreakdownReasonPlace).filter(function (item) {
                return poolRelationsById.resultObject.breakdownReasonPlaceIds.indexOf(item.id) > -1;
            });
            setSelectedBreakdownReasonPlace(
                filteredBreakdownReasonPlace.map((item, index) => ({
                    label: item.name,
                    value: item.id,
                    name: item.name
                }))
            );
        }
    }, [poolRelationsById]);

    useEffect(() => {
        if (editedPoolRelation?.data) {
            LoadHandler();
        }
    }, [editedPoolRelation]);

    const LoadHandler = () => {
        dispatch(getPoolById(queryString.parse(window.location.search).id));
    };

    //add data
    const AddHandler = () => {
        const data = {
            poolId: Number(queryString.parse(window.location.search).id),
            areaIds: selectedArea.map((item) => item.value),
            breakdownReasonGroupIds: selectedBreakdownReason.map((item) => item.value),
            maintenanceTypeIds: selectedMaintenanceType.map((item) => item.value),
            breakdownReasonPlaceIds: selectedBreakdownReasonPlace.map((item) => item.value),
            status: 1,
        };
        dispatch(editPoolRelation(data));
    };

    const history = useHistory();
    const TurnBack = () => {
        history.push({ pathname: "/pool/" });
    };

    const [selectedArea, setSelectedArea] = useState([]);
    const [selectedBreakdownReason, setSelectedBreakdownReason] = useState([]);
    const [selectedMaintenanceType, setSelectedMaintenanceType] = useState([]);
    const [selectedBreakdownReasonPlace, setSelectedBreakdownReasonPlace] = useState([]);

    return (
        <Container id="artpo_Container" maxWidth="md">
            <h1>{t("PoolInformation")}</h1>
            {pageLoaded === true ? (
                <Grid id="artpo_Grid" container spacing={3}>
                    <Grid id="artpo_Grid_1" item xs={12} sm={6} md={6}>
                        <TextField id="artpo_TextField" label={t("PoolCode")} defaultValue={data.code} InputProps={{ readOnly: true }} variant="outlined" />
                    </Grid>
                    <Grid id="artpo_Grid_2" item xs={12} sm={6} md={6}>
                        <TextField id="artpo_TextField_1" label={t("PoolName")} defaultValue={data.name} InputProps={{ readOnly: true }} variant="outlined" />
                    </Grid>
                    <Grid id="artpo_Grid_3" item xs={6} sm={6}>
                        <h4>{t("Areas")}</h4>
                        <Autocomplete
                            multiple
                            id="artpo_Autocomplete_1"
                            options={areaList}
                            limitTags={5}
                            value={areaList.filter((item) => Object.values(selectedArea).map((item) => {return item.name}).includes(item.name))}
                            disableCloseOnSelect={true}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} margin="normal" label={t("Areas")} variant="outlined" id="aug_table_TextField_0" />}
                            onChange={(event, newValue) => {
                                setSelectedArea(newValue)
                            }}
                            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
                            size={"normal"}
                        />
                    </Grid>
                    <Grid id="artpo_Grid_4" item xs={6} sm={6}>
                    <h4>{t("BreakdownPlaces")}</h4>
                        <Autocomplete
                            multiple
                            id="artpo_Autocomplete_2"
                            options={breakDownReasonPlaceList}
                            limitTags={5}
                            value={breakDownReasonPlaceList.filter((item) => Object.values(selectedBreakdownReasonPlace).map((item) => {return item.name}).includes(item.name))}
                            disableCloseOnSelect={true}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} margin="normal" label={t("BreakdownPlaces")} variant="outlined" id="aug_table_TextField_1" />}
                            onChange={(event, newValue) => {
                                setSelectedBreakdownReasonPlace(newValue)
                            }}
                            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
                            size={"normal"}
                        />
                    </Grid>
                    {/* <Grid id="artpo_Grid_5" item xs={6} sm={6}>
                        <h4>{t("TypesOfMaintenance")}</h4>
                        <MultiSelect
                            id="artpo_MultiSelect"
                            // options={allMaintenanceType}
                            options={maintenanceTypeList}
                            value={selectedMaintenanceType}
                            onChange={setSelectedMaintenanceType}
                            labelledBy={"Select"}
                            overrideStrings={stringTR}
                        />
                    </Grid>
                    <Grid id="artpo_Grid_6" item xs={6} sm={6}>
                        <pre style={{ marginTop: 25 }}>
                            <CustomList id="artpo_cl" dense={true} listItems={selectedMaintenanceType} />
                        </pre>
                    </Grid> */}
                    <Grid id="artpo_Grid_7" item xs={6} sm={6}>
                        <h4>{t("TypesOfBreakdowns")}</h4>
                        <Autocomplete
                            multiple
                            id="artpo_Autocomplete_3"
                            options={breakDownReasonGroupsList}
                            limitTags={5}
                            value={breakDownReasonGroupsList.filter((item) => Object.values(selectedBreakdownReason).map((item) => {return item.name}).includes(item.name))}
                            disableCloseOnSelect={true}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} margin="normal" label={t("TypesOfBreakdowns")} variant="outlined" id="aug_table_TextField_2" />}
                            onChange={(event, newValue) => {
                                setSelectedBreakdownReason(newValue)
                            }}
                            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
                            size={"normal"}
                        />
                    </Grid>
                    <Grid id="artpo_Grid_8" item xs={6} sm={6}>
                    </Grid>
                    <Grid id="artpo_Grid_9" item xs={6} sm={6} style={{ textAlign: "left" }}>
                        <Button id="artpo_Button" onClick={TurnBack} variant="contained" endIcon={<BackIcon />} style={{ marginRight: 15 }}>
                            {t("TurnBack")}
                        </Button>
                        <Button id="artpo_Button_1" onClick={() => AddHandler()} variant="contained" color="primary" endIcon={<CheckIcon />}>
                            {t("Save")}
                        </Button>
                    </Grid>
                </Grid>
            ) : null}
            <LoadingBackdrop id="artpo_lbd" />
        </Container>
    );
}
